// The beginnings of a reusable route URL object
export const ROUTE_URLS = {
  rules: '/groups/:groupId/entities',
};
